<template>
  <el-dialog top="10vh" title="谱例预览" width="1080px" :visible.sync="visible" :before-close="close" style="overflow-x:hidden !important">
    <iframe
      :src="`${RESOURCE_URL}?isThumb=${false}&music_id=${data.musical_id}&isScreening=`"
      width="1920"
      ref="iframe"
      @load="loadChange"
      frameborder="0"
      :style="`transform: scale(0.530749); transform-origin:left top; margin-bottom: ${-30}%;min-height: 800px`"
    ></iframe>
    <div _flex="~ wrap" _w="!950px" _border="3px solid [#F5F5F5] rounded-[10px]" _p="t-35px x-40px" _m="b-30px">
      <div
        v-for="item in list" :key="item.midi"
        style="box-shadow:0 0 5px 10px #BEDC79"
        _bg="[#88B03F]"
        _border="rounded-[9px]"
        _text="18px [#FFFFFF]"
        _w="80px"
        _h="80px"
        _flex="~ justify-center items-center"
        _m="r-30px b-35px"
        _cursor="pointer"
        _pos="relative"
        @click="selectItem(item)"
      >
        {{ item.cm?.toLowerCase() }}
        <i class="el-icon-refresh" _pos="absolute" _right="0px" _top="0px"/>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { cloneDeep } from 'lodash'
import { sameMidiNoteMap } from './const.js'
export default {
  model: {
		prop: 'visible',
		event: 'update:visible'
	},
	props: {
		visible: Boolean,
    data: Object,
    reset: Function
	},
  data() {
    return {
      sameMidiNoteMap,
      iframeMarginBottom: '',
      iframeMinHeight: '',
      RESOURCE_URL: '',
      list: [],
      isChanged: false,
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.RESOURCE_URL =  window.location.hostname != 'localhost' ? window.web_config.server_url + window.web_config.music_score_display_path : window.RESOURCE_URL
        // this.RESOURCE_URL = this.RESOURCE_URL.replace('music_score_display.html', 'music_score_rhythm.html')
        window.top.music_datas = {}
        window.top.music_datas[this.data.musical_id] = { 
          VOCAL_JSON: this.data.vocalJson, 
          abcResData: this.data.musciData, 
          visibility: {
            title: true,
            subhead: true,
            anAuthor: true,
            wordAuthor: true,
            speed: true,
            attr1: true,
            attr2: true,
            singAlongTitle: true
          }, 
        }
        this.list = cloneDeep(this.data.midiNoteMap.map(item => {
          return {
            ...item,
            count: 0,
            cms: this.sameMidiNoteMap[item.cm]
          }
        }))

      }
    }
  },
  methods: {
    loadChange() {
      const iframe = this.$refs.iframe;
      if (iframe) {
        const getHeight = () => {
          const iframeDocument = iframe.contentWindow ? iframe.contentWindow.document : iframe.contentDocument;
          const targetElement = iframeDocument.getElementById('target');
          const height = targetElement.style['min-height']
          if (height == '0px') {
            setTimeout(() => {
              getHeight()
            }, 300)
          } else {
            const num = Number(height.replace("px", ""))
            if (num < 1080 && num > 750) {
              this.iframeMarginBottom = '-47%'
            } else if (num < 750 && num > 600) {
              this.iframeMarginBottom = '-35%'
            } else if (num < 600 && num > 200) {
              this.iframeMarginBottom = '-20%'
            } else if (num > 1080) {
              this.iframeMarginBottom = -57 - (num - 1080) / 29 + '%'
            }
            this.iframeMinHeight = num + 30 + 79 + 'px'
          }
          const tool = iframeDocument.querySelector('.tool-container')
          if (tool) {
            tool.style.display = 'none'
          }
        }
        getHeight()
      }
    },
    close() {
      if (this.isChanged) {
        console.log('改变过数据需要清空干扰项，赋值正确项')
        const correct = cloneDeep(this.list)
        correct.forEach(el => {
          delete el.count
          delete el.cms
        })
        const filterUniqueFromFirstArray = (arr1, arr2, key) => {
          const set2 = new Set(arr2.map(item => item[key]));
          return arr1.filter(item => !set2.has(item[key]));
        }
        const error = filterUniqueFromFirstArray(this.data.allNoteMap, correct, 'cm')
        this.reset({ correct, error })
      }
			this.$emit('update:visible', false)
		},
    selectItem(note) {
      note.count++
      if (note.count > 2) {
        note.count = 0
      }
      this.isChanged = true
      note.cm = note.cms[note.count]
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
